import { Component, OnInit } from '@angular/core'
import { GraphqlService } from '@mprep/shared/data/services'
import { GraphqlResult } from '@mprep/shared/data/models'
import { PROGRAM_CODE_MAPPING, PROGRAM_ID_MAPPING, KBS_ENROLLMENT_PURCHASE_URL, KBS_TUTORING_EXTENSION_PRODUCT_IDS } from 'app/shared/helpers/constants'
import { NavigationService } from 'app/shared/services'
import { DateHelper } from '@mprep/shared/lib/helpers'

const NON_PURCHASABLE_TUTORING_PRODUCT_IDS = [
  1000027661, //LSAT Coaching Live Online
  1000027660, //LSAT Coaching In Person
]
const EA_PRODUCT_IDS = [
  1000044072,
  1000044070,
  1000044068,
  1000044069,
]

const MAX_PURCHASE_HOURS = 20
const MIN_PURCHASE_HOURS = 1

@Component({
  selector: 'mp-private-tutoring',
  templateUrl: './private-tutoring.html',
  styleUrls: ['./private-tutoring.scss']
})
export class PrivateTutoringComponent implements OnInit {
  public privateTutoringData = []
  public hasLoggedSessions: boolean = false
  // MP-TODO (refactor): Implement keyvalue pipe | Requires Angular 6+
  objectKeys = Object.keys
  private DEFAULT_TUTOR = 'To be determined'

  constructor(
    private _graphqlService: GraphqlService,
    private _navigationService: NavigationService,
    private _dateHelper: DateHelper
  ) { }

  public ngOnInit() {
    this._graphqlService.query('private_tutoring_view')
      .subscribe((graphQlResult: GraphqlResult) => {
        this._parse(graphQlResult)
      })
  }

  public goToPurchaseHours(tutor: {}, hours: string, program: string) {
    const productId = KBS_TUTORING_EXTENSION_PRODUCT_IDS[String(program).trim().toLowerCase()]
    const purchaseUrl = KBS_ENROLLMENT_PURCHASE_URL.replace(':enrollmentId', tutor['parentEnrollmentId']).replace(':quantity', hours).replace(':productId', productId)
    this._navigationService.navigateToUrl(purchaseUrl)
  }

  public changeHours(inputRef, value: string) {
    inputRef.value = parseInt(inputRef.value) + parseInt(value)
  }

  public isHoursMin(hours): boolean {
    return hours <= MIN_PURCHASE_HOURS
  }

  public isHoursMax(hours): boolean {
    return hours >= MAX_PURCHASE_HOURS
  }

  public formatDate(string) {
    return this._dateHelper.get(new Date(string)).format('YYYY-MM-DD')
  }

  private _parse(graphQlResult: GraphqlResult) {
    return graphQlResult.getResult()['Enrollment']
      .filter((enrollment) => enrollment.Tutoring != null && this._isParentEnrollment(enrollment))
      .sort((a, b) => this._dateComparator(a.Tutoring.Enrollment.createdOn, b.Tutoring.Enrollment.createdOn))
      .forEach((enrollment) => {
        this._parseEnrollment(enrollment)
      })
  }


  private _parseEnrollment(enrollment) {
    const enrollmentProgramId = parseInt(enrollment.Tutoring.Product.Program.id)
    const programId = EA_PRODUCT_IDS.some((id) => id == enrollment.Tutoring.Product.id) ? 100 : enrollmentProgramId
    const program = this._getOrCreateProgram(PROGRAM_CODE_MAPPING[programId])
    const tutor = this._getOrCreateTutor(program, this._formatTutor(enrollment.Tutoring.tutors))
    this._getOrCreateLog(program, this._formatTutor(enrollment.Tutoring.tutors))
    this._updateHours(tutor, enrollment.Tutoring)
    this._setEnrollmentId(tutor, enrollment)
    this._setIsPurchasable(tutor, enrollment)
    this._setLog(tutor, enrollment)
    tutor['productId'] = enrollment.Tutoring.Product.id
  }

  private _getOrCreateProgram(programName) {
    this.privateTutoringData[programName] = this.privateTutoringData[programName] || {}
    return this.privateTutoringData[programName]
  }

  private _getOrCreateTutor(program, tutorName) {
    const defaultTutor = { hoursUsed: 0, hoursPurchased: 0, hoursRemaining: 0, enrollmentParentId: 0 }
    program[tutorName] = program[tutorName] || defaultTutor
    return program[tutorName]
  }

  private _getOrCreateLog(program, tutorName) {
    program[tutorName]['log'] = program[tutorName]['log'] || []
  }

  private _formatTutor(tutors) {
    const tutor = tutors.find((tutor) => tutor.status == 'accepted')
    return tutor ? tutor.firstName + ' ' + tutor.lastName : this.DEFAULT_TUTOR
  }

  private _updateHours(tutor, hours) {
    this._addHoursPuchased(tutor, hours)
    this._addHoursUsed(tutor, hours)
    this._addHoursRemaining(tutor, hours)
  }

  private _addHoursPuchased(tutor, hours) {
    tutor.hoursPurchased += hours.tutoringHours
  }

  private _addHoursUsed(tutor, hours) {
    tutor.hoursUsed += (hours.tutoringHours - hours.tutoringRemainingHours)
  }

  private _addHoursRemaining(tutor, hours) {
    tutor.hoursRemaining += hours.tutoringRemainingHours
  }

  private _isParentEnrollment(enrollment): boolean {
    return enrollment.Tutoring.tutoringHours > 0
  }

  private _setEnrollmentId(tutor, enrollment) {
    tutor['parentEnrollmentId'] = enrollment.Tutoring.Enrollment.enrollmentId
  }

  private _setLog(tutor, enrollment) {
    if (Array.isArray(enrollment.Tutoring.logs) && enrollment.Tutoring.logs.length > 0) {
      this.hasLoggedSessions = true
      tutor['log'] = [...tutor['log'], ...enrollment.Tutoring.logs]
        .sort((a, b) => this._dateComparator(a.startTime, b.startTime))
    }
  }

  private _setIsPurchasable(tutor, enrollment) {
    tutor['purchasable'] = !NON_PURCHASABLE_TUTORING_PRODUCT_IDS.includes(enrollment.Tutoring.Product.id) &&
      enrollment.Tutoring.Product.Program.id != PROGRAM_ID_MAPPING.LSAT
  }

  private _dateComparator = (a, b) => {
    return new Date(b).getTime() / 1000 - new Date(a).getTime() / 1000
  }

}



// WEBPACK FOOTER //
// ./src/app/private-tutoring/private-tutoring.component.ts